import {api} from "../../../../api/API";
import {useAsyncAction} from "nate-react-api-helpers";
import {ReloadContext} from "../hardware/ReloadContext";
import {useContext, useState} from "react";
import {DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {Keying2Shortcode} from "../../../../api/Keying2";

export function EditNameDialog(props: {
    value: Keying2Shortcode;
    onClose: () => void
}) {
    const reload = useContext(ReloadContext);

    const update = useAsyncAction(async (input) => {
        await api.keying2.upsertShortcode(input);
        reload.emitter.emit(Date.now());
        props.onClose();
    }, []);

    const [name, setName] = useState(props.value.name);

    const submit = () => {
        update.callback({
            ...props.value,
            name,
        });
    };

    return (
        <Dialog2 open onClose={() => props.onClose()} onEnterPress={submit}>
            <DialogTitle>Edit Shortcode</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <TextField
                    label="Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onCancel={() => props.onClose()}
                onSubmit={submit}
            />
        </Dialog2>
    )

}